window.blazeSliders = {};

window.paginationUnique = sliderClass => {
  const resizeListener = () => {
    const topLeftArrow = document.querySelector(
      `${sliderClass}__pagination--top ${sliderClass}__pagination-left`
    );

    const topRightArrow = document.querySelector(
      `${sliderClass}__pagination--top ${sliderClass}__pagination-right`
    );

    if (window.innerWidth < 768) {
      topLeftArrow?.classList?.remove("blaze-prev");
      topRightArrow?.classList?.remove("blaze-next");
    } else if (
      !topLeftArrow?.classList.contains("blaze-prev") &&
      !topRightArrow?.classList?.contains("blaze-next")
    ) {
      topLeftArrow?.classList?.add("blaze-prev");
      topRightArrow?.classList?.add("blaze-next");
    }
  };

  window.addEventListener("resize", resizeListener);
  resizeListener();
};

window.blazeSliderPaginationDisable = (sliderClass, numberOfCards) => {
  const resizeSliderPagination = () => {
    const sliderEl = document.querySelector(`${sliderClass}`);
    const sliderElStart = document.querySelector(`${sliderClass} .start`);
    const sliderElPaginations = document.querySelectorAll(
      `${sliderClass} .blaze-pagination-custom .blaze-prev,${sliderClass}  .blaze-pagination-custom .blaze-next`
    );

    const slidesToShowStart = sliderElStart?.style.getPropertyValue("--slides-to-show");
    const slidesToShowContainer = sliderEl.style.getPropertyValue("--slides-to-show");
    const slidesToShow =
      parseInt(slidesToShowStart, 10) || parseInt(slidesToShowContainer, 10);

    for (const el of sliderElPaginations) {
      if (slidesToShow >= numberOfCards) {
        if (!el?.classList?.contains("d-none")) {
          el?.classList?.add("d-none");
        }
      } else {
        el?.classList?.remove("d-none");
      }
    }
  };

  resizeSliderPagination();
  window.addEventListener("resize", resizeSliderPagination);

  const blazePrevEl = document.querySelector(`${sliderClass} .blaze-prev`);
  const blazeNextEl = document.querySelector(`${sliderClass} .blaze-next`);

  if (blazePrevEl && blazeNextEl) {
 
  window.blazeSliders[sliderClass].onSlide(
    (_, firstVisibleSlideIndex, lastVisibleSlideIndex) => {
      if (lastVisibleSlideIndex === numberOfCards - 1) {
        if (!blazeNextEl?.classList?.contains("blaze-pagination--disabled")) {
          blazeNextEl.classList?.add("blaze-pagination--disabled");
        }
      } else {
        blazeNextEl.classList?.remove("blaze-pagination--disabled");
      }

      if (firstVisibleSlideIndex === 0) {
        if (!blazePrevEl?.classList?.contains("blaze-pagination--disabled")) {
          blazePrevEl.classList?.add("blaze-pagination--disabled");
        }
      } else {
        blazePrevEl.classList?.remove("blaze-pagination--disabled");
      }
    }
  );
}
};
